
<script>
    import { onMount } from "svelte";
    export let page = "Timer";
  
    // Show mobile icon and display menu
    let showMobileMenu = false;
  
    // List of navigation items
    const navItems = [
      "Temporizador",
      "Draw",
      "Debates",
      "Moções",
      "Calculadora",
      "Recursos",
      "Definições"
    ];
  
    // Mobile menu click event handler
    const handleMobileIconClick = () => (showMobileMenu = !showMobileMenu);
  
    // Media match query handler
    const mediaQueryHandler = e => {
      // Reset mobile state
      if (!e.matches) {
        showMobileMenu = false;
      }
    };
  
    // Attach media query listener on mount hook
    onMount(() => {
      const mediaListener = window.matchMedia("(max-width: 767px)");
  
      mediaListener.addListener(mediaQueryHandler);
    });
</script>
  
<nav>
  <div class="inner">
    <div on:click={handleMobileIconClick} class={`mobile-icon${showMobileMenu ? ' active' : ''}`}>
      <div class="middle-line"></div>
    </div>
    <ul class={`navbar-list${showMobileMenu ? ' mobile' : ''}`}>
      {#each navItems as item}
        <li>
          <a on:click={() => {page = item; showMobileMenu = false}}>{item}</a>
        </li>
      {/each}
    </ul>
  </div>
</nav>
  
<style>
  nav {
    position: absolute;
    z-index: 100;
    
    left: 0px;

    background-color: none;
    width: 100%;
    height: 6rem;
    
    align-items: center;
    justify-content: space-around;

    font-size: 24px;
  }
  
  .inner {
    padding-left: 20px;
    padding-right: 20px;
    margin: auto;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    height: 100%;
  }
  
  .mobile-icon {
    width: 25px;
    height: 14px;
    position: relative;
    cursor: pointer;
  }
  
  .mobile-icon:after,
  .mobile-icon:before,
  .middle-line {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    background-color: var(--font-color);
    transition: all 0.5s;
    transform-origin: center;
  }
  
  .mobile-icon:before,
  .middle-line {
    top: 0;
  }
  
  .mobile-icon:after,
  .middle-line {
    bottom: 0;
  }
  
  .mobile-icon:before {
    width: 66%;
  }
  
  .mobile-icon:after {
    width: 33%;
  }
  
  .middle-line {
    margin: auto;
  }
  
  .mobile-icon:hover:before,
  .mobile-icon:hover:after,
  .mobile-icon.active:before,
  .mobile-icon.active:after,
  .mobile-icon.active .middle-line {
    width: 100%;
  }
  
  .mobile-icon.active:before,
  .mobile-icon.active:after {
    top: 50%;
    transform: rotate(-45deg);
  }
  
  .mobile-icon.active .middle-line {
    transform: rotate(45deg);
  }
  
  .navbar-list {
    display: none;
    width: 100%;
    justify-content: space-between;
    margin: 0;
    padding: 0 2rem;
  }
 
  .navbar-list.mobile {
    background-color: var(--bg-color);
    position: fixed;
    display: block;
    height: calc(100% - 6rem);
    bottom: 0;
    left: 0;
    transition: 2s;
  }
  
  .navbar-list li {
    list-style-type: none;
    position: relative;
    margin-top: 2rem;
  }
  
  .navbar-list li:before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: var(--color-primary);
  }
  
  .navbar-list a {
    color: var(--font-color);
    text-decoration: none;
    display: flex;
    height: 45px;
    align-items: center;
    padding: 0 1rem;
    font-size: 2rem;
  }
    
</style>
  